export enum RolesEnum {
	OWNER = 0,
	ADMIN = 1,
	MEMBER = 2,
	COURIER = 100,
}
